module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "suspended-menu-wrapper"
    }
  }, [_c('a', {
    directives: [{
      name: "popover",
      rawName: "v-popover:suspended-menu.bottom",
      arg: "suspended-menu",
      modifiers: {
        "bottom": true
      }
    }],
    staticClass: "cursor-pointer"
  }, [_c('i', {
    staticClass: "fa fa-user",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('popover', {
    attrs: {
      "name": "suspended-menu"
    }
  }, [_c('ul', [_c('li', {
    on: {
      "click": function($event) {
        return _vm.openMyAccountModal()
      }
    }
  }, [_c('div', {
    staticClass: "clickable-item"
  }, [_c('i', {
    staticClass: "fa fa-user-circle-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('menu.suspenso.minhaConta'))
    }
  })])]), (!_vm.blockClientSelectButton) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.openClientModal()
      }
    }
  }, [_c('div', {
    staticClass: "clickable-item"
  }, [_c('i', {
    staticClass: "fa fa-users",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('menu.suspenso.clientes'))
    }
  })])]) : _vm._e(), (_vm.applicationList.length > 1) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.openAppChangeModal()
      }
    }
  }, [_c('div', {
    staticClass: "clickable-item"
  }, [_c('i', {
    staticClass: "fa fa-sign-out",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('menu.suspenso.apps'))
    }
  })])]) : _vm._e(), _c('li', {
    staticClass: "logout",
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_c('div', {
    staticClass: "clickable-item"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('menu.suspenso.logout'))
    }
  }), _c('i', {
    staticClass: "fa fa-power-off",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])])], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-07ceb7ab", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07ceb7ab"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/layout/menu/suspendedMenu.pug
// module id = 1360
// module chunks = 0